<template>
  <v-select
    v-if="schemaValue['options']"
    v-model="cloneRequestSchema"
    :label="schemaKey"
    small-chips
    multiple
    outlined
    prepend-icon="fab fa-pagelines"
    :items="schemaValue['options']"
    :persistent-hint="schemaValue['hint'] ? true : false"
    :hint="schemaValue['hint'] ? schemaValue['hint'] : ''"
  />
  <v-combobox
    v-else-if="schemaValue['type'] === 'TEXT-ARRAY'"
    v-model="cloneRequestSchema"
    :label="schemaKey"
    append-icon=""
    multiple
    outlined
    small-chips
    prepend-icon="fab fa-pagelines"
    :placeholder="schemaValue.type + ' (press enter to splite)'"
    :persistent-hint="schemaValue['thin'] ? true : false"
    :hint="schemaValue['hint'] ? schemaValue['hint'] : ''"
  />
  <v-checkbox
    v-else-if="schemaValue['type'] === 'BOOLEAN'"
    v-model="cloneRequestSchema"
    outlined
    :label="schemaKey"
    prepend-icon="fab fa-pagelines"
    :persistent-hint="schemaValue['hint'] ? true : false"
    :hint="schemaValue['hint'] ? schemaValue['hint'] : ''"
  />
  <v-textarea
    v-else
    v-model="cloneRequestSchema"
    :label="schemaKey"
    outlined
    :rows="1"
    prepend-icon="fab fa-pagelines"
    :placeholder="schemaValue.type"
    auto-grow
    :persistent-hint="schemaValue['hint'] ? true : false"
    :hint="schemaValue['hint'] ? schemaValue['hint'] : ''"
  />
</template>

<script>
import { cloneDeep } from 'lodash'
export default {
  props: ['value', 'schemaKey', 'schemaValue'],
  data() {
    return {
      cloneRequestSchema: undefined
    }
  },
  computed: {
    isRequestSchemaValueEmpty() {
      return (
        this.cloneRequestSchema === undefined || this.cloneRequestSchema === '' || this.cloneRequestSchema.length === 0
      )
    }
  },
  watch: {
    cloneRequestSchema: {
      deep: true,
      handler() {
        if (this.isRequestSchemaValueEmpty) this.cloneRequestSchema = undefined
        this.$emit('input', this.cloneRequestSchema)
      }
    }
  },
  created() {
    this.cloneRequestSchema = cloneDeep(this.value)
    if (this.isRequestSchemaValueEmpty) this.cloneRequestSchema = this.setInitValue(this.schemaValue.type)
  },
  methods: {
    setInitValue(type) {
      switch (type) {
        case 'TEXT':
          return ''
        case 'TEXT-ARRAY':
          return []
        case 'BOOLEAN':
          return false
      }
    }
  }
}
</script>

<style></style>
